// Shared vetting sign-out helpers (one copy for AuthLayout + the Settings drawer).

import { DOWNLOAD_RECORD_KEY } from '../vetting/lodgement-card';

const SIGN_OUT_ALL_MSG =
  'Sign out all devices?\n\nThis ends every signed-in session for your account, on every ' +
  'device, including this one. Other devices are signed out within about a minute. Passkeys ' +
  'are not affected; you can sign straight back in.';

/**
 * End every session for this account. Only redirects on a confirmed success —
 * on a failed request or a network error it says so and stays put, so a failed
 * "sign out all" is never silently shown as done (House Rules O: loud failure).
 */
export function signOutAllDevices(): void {
  if (!window.confirm(SIGN_OUT_ALL_MSG)) return;
  void fetch('/api/vetting/auth/logout-all', {
    method: 'POST',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    credentials: 'include',
  })
    .then((res) => {
      if (res.ok) {
        // The registrar card's download record goes with the session, as on
        // LogoutPage (cca-omhx, Lazo Low 2); throwing storage never blocks the redirect.
        try {
          window.localStorage.removeItem(DOWNLOAD_RECORD_KEY);
        } catch {
          // Storage unavailable — carry on signing out.
        }
        window.location.assign('/');
      } else {
        window.alert('Could not sign out all devices. Please try again.');
      }
    })
    .catch(() =>
      window.alert('Could not sign out all devices. Please check your connection and try again.'),
    );
}
